import { createSlice } from '@reduxjs/toolkit';
import { loadBusinessUnprocessedNcCounts } from './thunks/loadBusinessUnprocessedNcCounts';
import { loadProjectUnprocessedNcCount } from './thunks/loadProjectUnprocessedNcCount';

export const nonConformanceReportsSlice = createSlice({
  name: 'nonConformanceReports',
  initialState: {
    // projectId -> { projectId, count, bySubType: { nc, injury, close_call } }
    unprocessedCountByProject: {},
    // businessId -> { businessId, total, projects: [{ id, projectKey, name, count, bySubType }] }
    businessSummaryByBusinessId: {},
    loadingProjectCountByProject: {},
    loadingBusinessSummaryByBusinessId: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadProjectUnprocessedNcCount.pending, (state, action) => {
        const projectId = action.meta.arg;
        state.loadingProjectCountByProject[projectId] = true;
      })
      .addCase(loadProjectUnprocessedNcCount.fulfilled, (state, action) => {
        const projectId = action.meta.arg;
        state.loadingProjectCountByProject[projectId] = false;
        state.unprocessedCountByProject[projectId] = action.payload;
      })
      .addCase(loadProjectUnprocessedNcCount.rejected, (state, action) => {
        const projectId = action.meta.arg;
        state.loadingProjectCountByProject[projectId] = false;
      })
      .addCase(loadBusinessUnprocessedNcCounts.pending, (state, action) => {
        const businessId = action.meta.arg;
        state.loadingBusinessSummaryByBusinessId[businessId] = true;
      })
      .addCase(loadBusinessUnprocessedNcCounts.fulfilled, (state, action) => {
        const businessId = action.meta.arg;
        state.loadingBusinessSummaryByBusinessId[businessId] = false;
        state.businessSummaryByBusinessId[businessId] = action.payload;
      })
      .addCase(loadBusinessUnprocessedNcCounts.rejected, (state, action) => {
        const businessId = action.meta.arg;
        state.loadingBusinessSummaryByBusinessId[businessId] = false;
      });
  },
});

export default nonConformanceReportsSlice;
